// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// /home/pablo/vortex/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!/home/pablo/vortex/node_modules/vue-style-loader!/home/pablo/vortex/node_modules/css-loader?{"sourceMap":true}!/home/pablo/vortex/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5e89b418","scoped":false,"hasInlineConfig":false}!/home/pablo/vortex/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/index.vue
// module id = kQBy
// module chunks = 0